import { useEffect } from "react";
import banner from "../../../../_assets/images/agnostic-flow/banner.jpg";
import { Element } from "../../../Interface/scheduler/form";
import isInboundFromNbly from "../../../utility/checkInBoundFromNbly";
import { useFormConfigContext } from "../../contexts/FormConfigContext";
import "./Image.css";
import { sessionStorageUtils } from "../../../utility/utility";

const ImageElement = ({ element }: { element: Element }) => {
  const { formConfig } = useFormConfigContext();
  const isInbound = isInboundFromNbly();

  useEffect(() => {
    if (isInbound && formConfig?.brandLogoPath) {
      sessionStorageUtils.setItem("logo", formConfig.brandLogoPath);
    }
  }, [isInbound, formConfig?.brandLogoPath]);

  return (
    <>
      <div className={element.id} key={element.type}>
        <img
          src={element.src !== "" ? element.src : banner}
          alt={element.alt}
          width={element.width}
          height={element.height}
        />
      </div>
      {isInbound && formConfig?.brandLogoPath && (
        <div className="hamburgerViewLogoImageContainer">
          <div className="hamburgerViewLogoImage">
            <img src={formConfig.brandLogoPath} alt="brand logo" />
          </div>
        </div>
      )}
    </>
  );
};

export default ImageElement;
